var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.93772 12.2449L2.70813 9.3574C2.50735 9.26433 2.38358 9.05829 2.39572 8.83733C2.40785 8.61637 2.55345 8.42512 2.76321 8.35461L16.8897 3.60587C17.0881 3.53918 17.303 3.59367 17.4455 3.73733C17.589 3.87991 17.6434 4.09467 17.5768 4.29294L12.828 18.4194C12.7575 18.6292 12.5663 18.7748 12.3453 18.7869C12.1243 18.799 11.9183 18.6753 11.8252 18.4745L8.93772 12.2449ZM9.22788 11.1878L4.3936 8.94707L15.0513 5.36437L9.22788 11.1878ZM9.99479 11.9547L12.2356 16.789L15.8183 6.13128L9.99479 11.9547Z",
  fill: "#9498A0"
});

function SvgSendPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendPlane);
export default __webpack_public_path__ + "static/media/SendPlane.6e2c542a.svg";
export { ForwardRef as ReactComponent };